import { RootState } from '@store/redux.store'
import type { TaskTrackerState } from '../index'
import { createEmptyBoardFilterStickersBoardState } from './boardFilterStickers.state.utils'

type AppState = RootState & {
  taskTracker: TaskTrackerState
}

export const selectTaskTrackerBoardFilterStickersReloadToken = (
  state: AppState,
  boardId: number | null,
) => {
  if (boardId == null) return 0
  return state.taskTracker.boardFilterStickers.reloadTokens[boardId] ?? 0
}

export const selectTaskTrackerBoardFilterStickers = (
  state: AppState,
  boardId: number | null,
) => {
  if (boardId == null) return createEmptyBoardFilterStickersBoardState()
  return (
    state.taskTracker.boardFilterStickers.byBoardId[boardId] ??
    createEmptyBoardFilterStickersBoardState()
  )
}

export const selectTaskTrackerBoardAccessibleStickerRows = (
  state: AppState,
  boardId: number | null,
) => selectTaskTrackerBoardFilterStickers(state, boardId).visibleStickerRows

export const selectTaskTrackerBoardAllStickerRows = (
  state: AppState,
  boardId: number | null,
) => selectTaskTrackerBoardFilterStickers(state, boardId).allStickerRows

export type { TaskTrackerBoardFilterStickerRow } from '../domain.types'
